import { useEffect } from 'react'

import { STORAGE, getRememberFlag, getSessionStorage } from '@/shared/lib/storage'

const parseUserId = (raw: string | null): string => {
  if (!raw) return ''
  try {
    const info = JSON.parse(raw) as { id?: string | number; userId?: string | number } | null
    const id = info?.id ?? info?.userId
    return id == null ? '' : String(id)
  } catch {
    return ''
  }
}

/**
 * Tab khác đổi tài khoản, hoặc xoá user-info / xoá sạch localStorage → tải lại trang để
 * khỏi gửi token và quyền lệch nhau. Chỉ so id của giá trị cũ và mới trong sự kiện
 * `storage` (chỉ localStorage, tab khác mới nhận được); ghi lại cùng id (refresh profile,
 * refresh token) không reload.
 */
export const useCrossTabAuthSync = (enabled = true): void => {
  useEffect(() => {
    if (!enabled) return

    const onStorage = (e: StorageEvent) => {
      if (e.storageArea !== localStorage) return
      // Tab "không ghi nhớ" (user-info ở sessionStorage) có phiên riêng: reload ở đây vô nghĩa.
      if (getRememberFlag() === false || getSessionStorage(STORAGE.USER_INFO) != null) return
      if (e.key === null) {
        window.location.reload()
        return
      }
      if (e.key !== STORAGE.USER_INFO) return
      const oldId = parseUserId(e.oldValue)
      const newId = parseUserId(e.newValue)
      // Cả hai id rỗng nhưng giá trị khác nhau (vd {} → {x}) vẫn coi là đổi phiên.
      const changed = oldId !== newId || (oldId === '' && e.oldValue !== e.newValue)
      if (changed) window.location.reload()
    }

    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [enabled])
}
